import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';
import { dateParams as dateParamsUtil } from './utilities';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.Hits.meta.exhausted) return;
    if (getState().AnalyticsDashboard.Hits.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_HITS_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    Ajax.HitsService(dateParams)
      .done(function (hitsResponse) {
        dispatch({
          type: TYPES.FETCH_HITS_SUCCESS,
          hits: hitsResponse.hits,
          aggregatedOccupations: hitsResponse.aggregated_occupations,
          aggregatedUniversities: hitsResponse.aggregated_universities,
          aggregatedDocs: hitsResponse.aggregated_docs,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_HITS_FAILURE,
        });
      });
  };
};

const Hits = {
  fetch: fetch,
};
export { Hits };

const initialState = {
  models: [],
  aggregatedOccupations: [],
  aggregatedUniversities: [],
  aggregatedDocs: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_HITS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_HITS_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.hits),
        aggregatedOccupations: state.aggregatedOccupations.concat(
          action.aggregatedOccupations,
        ),
        aggregatedUniversities: state.aggregatedUniversities.concat(
          action.aggregatedUniversities,
        ),
        aggregatedDocs: state.aggregatedDocs.concat(action.aggregatedDocs),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_HITS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
